export default class FilterDropdown {
  constructor({ el }) {
    this.el = el;

    this.clicker = this.el.querySelector('.clicker');
    this.filterValues = this.el.querySelector('.filter-values');
    this.filterValuesInner = this.el.querySelector('.filter-values-inner');
    this.icon = this.clicker.querySelector('.icon');
    this.height = 800;

    // get other filter dropdowns
    this.otherFilterDropdowns = document.querySelectorAll('.filter-dropdown');

    this.init();
  }

  init() {
    this.clicker.addEventListener('click', (e) => {
      e.preventDefault();

      if (this.el.classList.contains('active')) {
        this.el.classList.remove('active');
        this.filterValues.style.height = '0px';
        if (this.icon) this.icon.innerHTML = '+';
      } else {
        // remove active class from other filter dropdowns
        this.otherFilterDropdowns.forEach((dropdown) => {
          dropdown.classList.remove('active');

          // set height to 0
          dropdown.querySelector('.filter-values').style.height = '0px';

          // set icon to +
          dropdown.querySelector('.icon').innerHTML = '+';
        });

        this.el.classList.add('active');
        if (this.icon) this.icon.innerHTML = '-';

        // get content inner height
        const contentInnerHeight = this.filterValuesInner.clientHeight;

        // if height is greater than 140px, set to 140px
        if (contentInnerHeight > this.height && !this.el.classList.contains('no-height-limit')) {
          contentInnerHeight = this.height;
          this.filterValues.classList.add('show-gradient');
          this.filterValues.style.overflowY = 'auto';
        } else {
          this.filterValues.classList.remove('show-gradient');
          this.filterValues.style.overflowY = 'hidden';
        }

        // set content height
        this.filterValues.style.height = `${contentInnerHeight}px`;
      }
    });
  }
}
